import * as actionTypes from '../constants';

const initialState = {
  inProducts: [],
  apaveProducts: [],
  bookmarkProducts: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_UPDATE_INPRODUCTS:
      return { ...state, inProducts: action.payload };
    case actionTypes.ACTION_UPDATE_APAVEPRODUCTS:
      return { ...state, apaveProducts: action.payload };
    case actionTypes.ACTION_UPDATE_BOOKMARKPRODUCTS:
      return { ...state, bookmarkProducts: action.payload };
    default:
      return state;
  }
}
